export default __webpack_public_path__ + "static/media/nodeJS-logo.e71346fe.png";